import { getRouteApi, useNavigate } from '@tanstack/react-router';

import { FormattedMessage, useIntl } from 'react-intl';

import AppBar from '@mui/material/AppBar';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import Toolbar from '@mui/material/Toolbar';
import BackIcon from '@mui/icons-material/ArrowBack';

import Spacings from '~/modules/ui-kit/spacings';
import generalMessages from '~/containers/App/messages';

import ContentView from '~/components/ContentView';
import CircuitForm from '~/components/CircuitForm';

import { useCreateCircuit } from '~/hooks/api/useCreateCircuit';
import { useSnackbar } from '~/containers/Snackbar/SnackbarContext';
import messages from './messages';

const route = getRouteApi('/circuits/new');

export const CircuitCreate = () => {
  const intl = useIntl();
  const navigate = useNavigate();
  const { showSnackbar } = useSnackbar();
  const search = route.useSearch();
  const goToCircuitsList = () => {
    navigate({ to: search.from || '/circuits' });
  };

  const mutation = useCreateCircuit({
    onSuccess() {
      showSnackbar({
        message: intl.formatMessage(messages.saveSuccess),
      });
      goToCircuitsList();
    },
    onError() {
      showSnackbar({
        message: intl.formatMessage(messages.saveFailure),
      });
    },
  });

  return (
    <ContentView
      header={
        <AppBar position="static">
          <Toolbar>
            <Spacings.Inline alignItems="center">
              <IconButton
                color="inherit"
                onClick={goToCircuitsList}
                size="large"
              >
                <BackIcon data-testid="back" />
              </IconButton>
              <div>
                <Typography
                  variant="h6"
                  sx={{
                    color: 'inherit',
                  }}
                >
                  <FormattedMessage {...messages.title} />
                </Typography>
              </div>
            </Spacings.Inline>
          </Toolbar>
        </AppBar>
      }
      isLoading={mutation.isPending}
    >
      <CircuitForm onSubmit={mutation.mutate}>
        <div>
          <Button
            disabled={mutation.isPending}
            color="primary"
            type="submit"
            variant="contained"
          >
            {mutation.isPending ? (
              <FormattedMessage {...generalMessages.loading} />
            ) : (
              <FormattedMessage {...messages.saveButton} />
            )}
          </Button>
        </div>
      </CircuitForm>
    </ContentView>
  );
};

export default CircuitCreate;
